import { boot } from 'quasar/wrappers'
import { useVuelidate } from '@vuelidate/core';

export default boot(async ({ app }) => {
	app.use(useVuelidate)
})
